import { useEffect } from "react";
import { useSelector } from "react-redux";

import { Modal } from "@/components/modal/modal";
import { Button, FormSize } from "ui/ecosystems/forms";
import { Spinner } from "@/components/ui/spinner";
import { LinkedInProfile } from "api/social-account-connect/linkedin";

import { LinkedinProfileList } from "../linkedin-profile-list";
import { NeedHelpButton } from "../need-help-button";
import { addLinkedInProfileFx, loginWithLinkedInFx } from "./model";
import { getConnectButtonStateFactory } from "../connect-button";
import { PlatformTypes } from "features/post";
import {
  dispatchAppAction,
  selectSocialConnectLinkedinState,
  socialAccountConnectActions,
} from "../../redux-model";

interface LinkedinConnectDialogProps {
  show: boolean;
  onHide(): void;
  onBack(): void;
  isAlreadyAdded(profile: LinkedInProfile): boolean;
}

export function LinkedinConnectDialog({
  show,
  onHide,
  onBack,
  isAlreadyAdded,
}: LinkedinConnectDialogProps) {
  const { profiles, isLoggingIn, connectingProfileId } = useSelector(
    selectSocialConnectLinkedinState
  );

  useEffect(() => {
    return () => {
      if (show) {
        dispatchAppAction(
          socialAccountConnectActions.resetLinkedinDialogState()
        );
      }
    };
  }, [show]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title>LinkedIn connection</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {profiles ? (
          <LinkedinProfileList
            profiles={profiles}
            onConnect={addLinkedInProfileFx}
            onReconnect={() => void loginWithLinkedInFx()}
            getConnectButtonState={getConnectButtonStateFactory({
              isConnected: isAlreadyAdded,
              isConnecting: (profile) => profile.id === connectingProfileId,
              isDisabled: () => Boolean(connectingProfileId) || isLoggingIn,
            })}
          />
        ) : (
          <div className="flex items-center justify-center py-8">
            <Spinner size="lg" />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button text size={FormSize.large} onClick={onBack}>
          Back
        </Button>
        <NeedHelpButton
          platform={PlatformTypes.linkedin}
          chatQuery="accounts"
        />
      </Modal.Footer>
    </Modal>
  );
}
